module.exports = __webpack_public_path__ + "img/C-返回.16f0f0fe.png";